import { isIOS } from "react-device-detect"
import { store } from '../components/provider/ReduxProvider';
import { URL } from "../constant";
import { setAppBackbtnEventData } from "../redux/common";
import { initial } from '../redux/errorState';
import { mathpidLogAPICall } from "../redux/logData";
import { appKillFunc, getUserAgent, openOcr, openWebBrowser } from "./utilityEtc";

export const appAmplitudeEventFunc = (data, type) => {
  if (process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'local') {
    console.log(`***** app amplitude data: ${JSON.stringify( data, null, 2)}`);
    console.log(`***** app amplitude type: ${JSON.stringify( type )}`);
  }
  if (isIOS) {
    if (type === 'setAmplitude') {
      (window.webkit && window.webkit.messageHandlers?.setAmplitude) && window.webkit.messageHandlers.setAmplitude.postMessage(JSON.stringify(data));
    } else if (type === 'logAmplitude') {
      (window.webkit && window.webkit.messageHandlers?.logAmplitude) && window.webkit.messageHandlers.logAmplitude.postMessage(JSON.stringify(data));
    } else if (type === 'regenAmplitude') {
      (window.webkit && window.webkit.messageHandlers?.regenAmplitude) && window.webkit.messageHandlers.regenAmplitude.postMessage('');
    }
    return;
  } else {
    if (type === 'setAmplitude') {
      (window.aicalculator && window.aicalculator?.setAmplitude) && window.aicalculator.setAmplitude(JSON.stringify(data));
    } else if (type === 'logAmplitude'){
      (window.aicalculator && window.aicalculator?.logAmplitude) && window.aicalculator.logAmplitude(JSON.stringify(data));
    } else if (type === 'regenAmplitude') {
      (window.aicalculator && window.aicalculator?.regenAmplitude) && window.aicalculator.regenAmplitude();
    }
  }
}

export const appBackBtnEventFunc = ({ history, lastLocation }) => {

  /**
   * const event = new Event('appBackBtnEvent'); window.dispatchEvent(new CustomEvent('appBackBtnEvent', {detail: {test: 'testttt'}}));
   */
  window.addEventListener('appBackBtnEvent', (e) => {

    // 앱 백그라운드 xapi evnet call
    store.dispatch(mathpidLogAPICall({
      verbId: 'unfocused',
      objectId: 'application',
      idName: getUserAgent('packageName'),
      idValue: getUserAgent('VERSION_NAME')
    }));

    const { common, user } = store.getState();

    if (!common?.appBackBtnEventData) {
      history.goBack();
      return;
    }
    
    const { pathname = '', state = null, eventFunc = null } = common.appBackBtnEventData;
    // console.log({ appBackBtnEventData: common.appBackBtnEventData, l: lastLocation, h: history });

    // 열려 있던 Alert 종료
    store.dispatch(initial());

    if (window.location.pathname === URL.SELECT_LEARNING) {
      console.log("###### 앱 종료");
      appKillFunc();
      return;
    }

    const initState = { pathname: '', state: null, eventFunc: null, isPush: false };

    if (eventFunc) {
      eventFunc();
      store.dispatch(setAppBackbtnEventData(initState));
      return;
    }

    if (pathname) {
      store.dispatch(setAppBackbtnEventData(initState));
      history.replace({ pathname, state });
    } else {
      switch (window.location.pathname) {
        case URL.ACCOUNT.JOIN.SUCCESS:
        case URL.ACCOUNT.LEAVE_SUCCESS:
        case URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ANALYSIS:
          // App back버튼 아무 동작 안함.
          break;
        case URL.OCR.HISTORY:
        case URL.OCR.RECOMMEND_LEARNING:
        case URL.OCR.USAGE:
          openOcr(user?.info?.learnerId);
          break;
        default:
          history.goBack();
          break;
      }
    }
    
  });
}

export const appAppsflyerEventFunc = (data) => {
  if (process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'local') {
    console.log("##### appsflyer event data: ", data);
  }

  if (isIOS) {
    if (window.webkit && window.webkit.messageHandlers?.logAppsflyer) {
      window.webkit.messageHandlers.logAppsflyer.postMessage(data);
    }

    return
  }else {
    if (window.aicalculator && window.aicalculator?.logAppsflyer) {
      window.aicalculator.logAppsflyer(data);
    }

    return;
  }
}

export const appAppsflyerEventCuidSetFunc = (cuid) => {
  if (process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'local') {
    console.log("##### appsflyer event cuid: ", cuid);
  }

  if (isIOS) {
    if (window.webkit && window.webkit.messageHandlers?.setAppsflyer) {
      window.webkit.messageHandlers.setAppsflyer.postMessage(cuid);
    }

    return
  } else {
    if (window.aicalculator && window.aicalculator?.setAppsflyer) {
      window.aicalculator.setAppsflyer(cuid);
    }

    return;
  }
}

export const appOpenMathFarm = () => {

  try {
    if (isIOS) {
      if (window.webkit && window.webkit.messageHandlers?.openMathFarm) {
        window.webkit.messageHandlers.openMathFarm.postMessage('');
      } else {
        openWebBrowser("https://apps.apple.com/kr/app/%EC%A7%80%EB%8B%88%EC%9D%98-%EB%A7%A4%EC%93%B0%ED%8C%9C/id1634758794");
      }
      return
    } else {
      if (window.aicalculator && window.aicalculator?.openMathFarm) {
        window.aicalculator.openMathFarm()
      } else {
        openWebBrowser("https://play.google.com/store/apps/details?id=com.RootJade.MathFarm");
      }
      return;
    }
  } catch (error) {
    openWebBrowser(
      isIOS
        ? "https://apps.apple.com/kr/app/%EC%A7%80%EB%8B%88%EC%9D%98-%EB%A7%A4%EC%93%B0%ED%8C%9C/id1634758794"
        : "https://play.google.com/store/apps/details?id=com.RootJade.MathFarm"
    );
  }

}

export const appForegroundEvent = () => {
  window.addEventListener('foregroundApp', (e) => {
    // 앱 백그라운드 xapi evnet call
    store.dispatch(mathpidLogAPICall({
      verbId: 'focused',
      objectId: 'application',
      idName: getUserAgent('packageName'),
      idValue: getUserAgent('VERSION_NAME')
    }));
  })
}

export const appBbackgroundEvent = () => {
  window.addEventListener('backgroundApp', (e) => {
    // 앱 백그라운드 xapi evnet call
    store.dispatch(mathpidLogAPICall({
      verbId: 'unfocused',
      objectId: 'application',
      idName: getUserAgent('packageName'),
      idValue: getUserAgent('VERSION_NAME')
    }));
  })
}